import {
  GLOBAL_TRANSLATION_FAILURE_ID,
  useFormDataContext,
} from "@totalenergiescode/mobility-business-rev-form-data/components";
import type { SubmittedData } from "@totalenergiescode/mobility-business-rev-form-data/lib";
import { type ReactNode } from "react";

import DefaultSummaryRenderer from "@/components/FormData/lib/layout/Renderers/DefaultSummaryRenderer";
import NavigationRenderer from "@/components/FormData/lib/layout/Renderers/NavigationRenderer";
import StepRenderer from "@/components/FormData/lib/layout/Renderers/StepRenderer";
import TranslationFailureIndicator from "@/components/FormData/lib/layout/Renderers/TranslationFailureIndicator";

export interface FormDataRendererProps {
  onSubmitted?: (data: SubmittedData) => Promise<void>;
  summaryNode?: ReactNode; // 👈 this lets you pass <SomeNode />
}

const FormDataRenderer = ({
  onSubmitted,
  summaryNode,
}: FormDataRendererProps) => {
  const { form, translator, debug, debugAllowed } = useFormDataContext();

  const showSummary = form.canDisplaySummary();

  return (
    <>
      {debugAllowed ? (
        <div>
          Debug Mode: {debug ? "ON" : "OFF"} (press twice the letter d to
          toggle...)
          <TranslationFailureIndicator
            targetId={GLOBAL_TRANSLATION_FAILURE_ID}
          />
        </div>
      ) : null}

      {showSummary ? (
        <>
          {summaryNode ?? <DefaultSummaryRenderer />}
          <NavigationRenderer onSubmitted={onSubmitted} />
        </>
      ) : form.hasCurrentStep() ? (
        <StepRenderer stepNumber={form.findCurrentStep()?.number ?? 0} />
      ) : (
        <div>{translator.translate("formData.form.noStep")}</div>
      )}
    </>
  );
};

export default FormDataRenderer;
